import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Alert } from '@mui/material';

const ResendConfirmDialog = ({ open, onClose, onConfirm, submitting, errorMessage, providerEmail }) => (
  <Dialog
    open={open}
    onClose={submitting ? undefined : onClose}
    aria-labelledby="resend-dialog-title"
    aria-describedby="resend-dialog-description"
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle id="resend-dialog-title" sx={{ fontWeight: 600 }}>
      Resend approval request?
    </DialogTitle>
    <DialogContent>
      <Typography id="resend-dialog-description" variant="body2" color="text.secondary">
        Resending rotates the secure link. The previous link will stop working immediately.
        {providerEmail ? ` The new link will be emailed to ${providerEmail}.` : ''}
      </Typography>
      {errorMessage && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {errorMessage}
        </Alert>
      )}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} disabled={submitting} variant="text">
        Cancel
      </Button>
      <Button onClick={onConfirm} disabled={submitting} variant="contained" disableElevation>
        {submitting ? 'Resending…' : 'Resend now'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ResendConfirmDialog;
